import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "small text-danger"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "small text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("label", null, "Numero massimo QR", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "number",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.generatedQrLimit) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.generatedQrLimit]
      ]),
      (!_ctx.qrLimitsOk)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "I QR attivi superano il numero massimo"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("label", null, "Numero massimo QR attivi", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "number",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.activeQrLimit) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.activeQrLimit]
      ]),
      (!_ctx.qrLimitsOk)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "I QR attivi superano il numero massimo"))
        : _createCommentVNode("", true)
    ])
  ]))
}